import React from "react";
import FrecciaIndietro from "../../commons/FrecciaIndietro";
import Space from "../../commons/Space";
import foto from "../../images/News/Chiusura_estivs.png"
import TitoloSezioni from "../../commons/TitoloSezioni";
import "./NewsPagesFoto.css"
import ScrollToTopOnMount from "../../components/ScrollToTopOnMount";
import "../../styles/List.css"
import Bar_3 from "../../components/Bar_3";


function Chiusura2025 () {
    return(
        <div className="text-center">
            <ScrollToTopOnMount />
            <FrecciaIndietro indirizzo={"/news"} />
            <p className="text-center" style={{ fontSize: "22px", fontFamily: "Hammersmith One" }}>{""}</p>
            <div className="container-foto-news m-auto" style={{display: "flex", flexDirection: "column"}}>
                <img src={foto} style={{width: "100%"}}></img>
            </div>
            <Space />

        </div>
    )
}
export default Chiusura2025